<template>
  <div>
    <div class="autoScaling-title">
      <div>{{ $t("RAM.ALI.AutoScaling.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:autoScaling:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:autoScaling:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="autoScaling-top">
      <auto-scaling-search ref="child"></auto-scaling-search>
    </div>
    <table-auto-scaling></table-auto-scaling>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import AutoScalingSearch from "./AutoScalingSearch";
import TableAutoScaling from "./TableAutoScaling";
import Export from "../Export";

export default {
  name: "AutoScaling",
  components: {
    AutoScalingSearch,
    TableAutoScaling,
    Export
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: "",
      pageNum: "",
      pageSize: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.child.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 300,
          accountType: 1
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        accountName: this.$refs.child.accountName,
        companyId: this.$refs.child.companyId,
        scalingGroupName: this.$refs.child.scalingGroupName,
        pageNum: this.$refs.child.pageNum,
        pageSize: this.$refs.child.pageSize
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAliAutoScalingGroup(exportDTO)
        .then(res => {
          let fileName = this.$t('RAM.export.aliAutoScaling');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.autoScaling-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.autoScaling-title > div:nth-child(1) {
  float: left;
}
.autoScaling-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.autoScaling-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/autoScaling/AutoScaling.vue